import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./index.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faTimes, faPen, faSearchPlus, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { faPlusSquare, faCheckCircle, faCaretSquareDown, faClock, faQuestionCircle } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import ConfirmModal from './components/ConfirmModal.vue';

Vue.component('ssg-confirm-modal', ConfirmModal);

library.add(faPlusSquare, faTimes, faPen, faCaretSquareDown, faCheckCircle, faSearchPlus, faInfoCircle, faClock, faQuestionCircle);

import VueEasyLightbox from "vue-easy-lightbox";

Vue.use(VueEasyLightbox);
Vue.component("sf-icon", FontAwesomeIcon);
Vue.config.productionTip = false;

Vue.filter("formatPrice", function (value) {
  return value
    .toFixed(2)
    .toString()
    .replace(".", ",")
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
});

if (process.env.NODE_ENV === "development") Vue.prototype.$setPreview = "JDJ5JDEwJGhKMlVtYm5qZUdKWmNPUDhHSTNDbS5QSWpNZWp4Zy5rUlRXaW9UeWhiRkY3NFQxNFQuLlRP";

window.sfVue = new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#schattenfix-konfigurator");